import { Box, useAnimatedNative } from '../../../../../../../../mads';

import { colors } from '@indeed/ifl-tokens';
import React, { useEffect, useRef } from 'react';
import { Animated, Easing, StyleSheet } from 'react-native';
import { Path, Svg } from 'react-native-svg';

const componentStyle = StyleSheet.create({
    main: {},
});

const AnimatedPath = Animated.createAnimatedComponent(Path);

const AnimatedCheckmarkIcon: React.FunctionComponent = () => {
    const strokeDashoffset = useRef(new Animated.Value(48)).current;
    const useNativeDriver: boolean = useAnimatedNative();

    useEffect(() => {
        const animation = Animated.timing(strokeDashoffset, {
            toValue: 0,
            duration: 1000, // 1s
            delay: 0, // 0.2s
            easing: Easing.ease,
            useNativeDriver,
        });

        animation.start();

        return () => {
            animation.stop();
        };
    }, [strokeDashoffset, useNativeDriver]);

    return (
        <Box
            sx={{
                alignItems: 'center',
            }}
        >
            <Svg
                viewBox="0 0 48 48"
                width={32}
                height={32}
                strokeWidth={4}
                stroke={colors.neutral[0]}
                strokeMiterlimit={10}
                style={[componentStyle.main]}
            >
                <AnimatedPath
                    fill="none"
                    d="M14.1 27.2l7.1 7.2 16.7-16.8"
                    strokeDasharray={48}
                    strokeDashoffset={strokeDashoffset}
                />
            </Svg>
        </Box>
    );
};

export default AnimatedCheckmarkIcon;
